@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.linkshare
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.linkshare.LinkShareLogDto
import com.narbase.letsgo.web.models.linkshare.SharedLocationType

object GetLinkShareLogsEndpoint : EndPoint<GetLinkShareLogsEndpoint.Request, GetLinkShareLogsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val sharedByPassengerId: KmmLong?,
        val openedByPassengerId: KmmLong?,
        val shareToken: String?,
        val rideId: KmmLong?,
        val rideCreated: Boolean?,
        val rideFinalStatus: String?,
        @Suppress("NON_EXPORTABLE_TYPE") val sharedLocationType: DtoName<SharedLocationType>?,
        val sharedFrom: KmmLong?,
        val sharedTo: KmmLong?,
        val openedFrom: KmmLong?,
        val openedTo: KmmLong?,
        val rewardEligible: Boolean?,
        val rewardSent: Boolean?,
        val os: String?,
        val webVersion: String?,
    )

    class Response(
        val list: Array<LinkShareLogDto>,
        val total: Int,
    )
}
